import type { ButtonHTMLAttributes, CSSProperties, ReactNode } from "react";
import { buttonSpec, type ButtonSize, type ButtonVariant } from "../specs/controls";
import { mergeVars, typographyClass } from "../specs/types";
import { Loader } from "./Loader";

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type"> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  fullWidth?: boolean;
  iconOnly?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  htmlType?: "button" | "submit" | "reset";
}

export function Button({
  variant = buttonSpec.defaults.variant,
  size = buttonSpec.defaults.size,
  loading = false,
  fullWidth = false,
  iconOnly = false,
  startIcon,
  endIcon,
  htmlType = "button",
  children,
  className,
  style,
  disabled,
  ...rest
}: ButtonProps) {
  const sizeSpec = buttonSpec.sizes[size];
  const vars = mergeVars(buttonSpec.base, sizeSpec.vars, buttonSpec.variants[variant]);

  return (
    <button
      {...rest}
      type={htmlType}
      disabled={disabled || loading}
      data-full={fullWidth}
      data-icon-only={iconOnly}
      className={["ui-button", typographyClass(sizeSpec.typography), className].filter(Boolean).join(" ")}
      style={{ ...(vars as CSSProperties), ...style }}
    >
      {loading ? <Loader size="small" /> : startIcon}
      {!iconOnly && children}
      {!loading && endIcon}
    </button>
  );
}
